/**
 * Visitor analytics count real visitors to the published site only.
 *
 * 2026-10-14: 407 of the last 30 days' 607 page_visits rows (67%) carried
 * referrer lovable.dev, i.e. the operator editing the site in Lovable, whose
 * editor frames the app. Every edit session was counted as a visitor, and
 * "top referrer" was the editor itself.
 *
 * An allowlist, not a denylist: a new preview or staging host stays out of the
 * numbers by default. Add a host here when the site is published on one.
 */
export const PRODUCTION_ANALYTICS_HOSTS = ['akiva.com', 'www.akiva.com'] as const;

export function isTrackableVisit(hostname: string, framed: boolean): boolean {
  if (framed) return false;
  return (PRODUCTION_ANALYTICS_HOSTS as readonly string[]).includes(hostname.toLowerCase());
}

/** Evaluated in the browser: the current page is a real visit to the published site. */
export function isTrackableBrowserVisit(): boolean {
  if (typeof window === 'undefined') return false;
  let framed: boolean;
  try {
    framed = window.self !== window.top;
  } catch {
    // A cross-origin parent makes window.top inaccessible in some browsers.
    framed = true;
  }
  return isTrackableVisit(window.location.hostname, framed);
}
